
import React from "react";

import sponsor1 from "../../assets/images/maria.png";
import sponsor2 from "../../assets/images/gilda.png";
import sponsor3 from "../../assets/images/neostrata.png";
import sponsorWebshop from "../../assets/images/neostrata_webbshop.jpg";

export default function BrandsSection() {
  const brands = [
    {
      name: "Maria Åkerberg",
      logo: sponsor1
    },
    {
      name: "Gilda Liljeblad",
      logo: sponsor2
    },
    {
      name: "Neostrata",
      logo: sponsor3
    }
  ];

  return (
    <>
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2
            className="text-4xl font-semibold text-center mb-12"
            style={{ color: 'var(--secondary)' }}
          >
            Våra Varumärken
          </h2>
          <div className="grid md:grid-cols-3 gap-12 items-center">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
              >
                <img
                  src={brand.logo}
                  alt={`${brand.name} produkter - Salong Milepa`}
                  className="max-h-24 w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Neostrata Webbshop Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src={sponsorWebshop}
                alt="Neostrata Produkter"
                className="rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-gray-800">
                Handla Neostrata Online
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Vi är stolta över att vara återförsäljare av Neostratas premiumskönhetsprodukter! Du kan även besöka oss i salongen för att upptäcka vårt noga utvalda sortiment och få skräddarsydda rekommendationer.
              </p>
              <a
                href="https://neostrata.se/#clinic=984&link=9f23739e"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  className="px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                  style={{ backgroundColor: 'var(--secondary)' }}
                >
                  Besök Vår Webbshop
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
